//import BaseServices from "../base-services/BaseServices";
//import { StorageServices } from "..";
import { IBaseItem } from "../../modules/common/types";

//const ControllerBase: string = "Person";

export default class PersonServices {

    public static async GetGenders() {
        let data: IBaseItem[] = [];

        try {
            // const userCred = StorageServices.GetCookieUserCredentials();

            // data = await BaseServices.GetServices(ControllerBase, `products?userid=${userCred.UserId}&platformid=${userCred.PlatformId}`);
            data = [
                {Id: 1, Name: 'Masculino'},
                {Id: 2, Name: 'Femenino'},
                {Id: 3, Name: 'Unisex'},
                //{Id: 3, Name: 'Sin Definir'}
            ];

        } catch (error) {
            console.log(error);
        }

        return data;
    }
}